import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/shared/components/component-base';
import { LoginInput, UserDto } from '../../models/user-dto';
import { SharedModule } from '../../shared.module';
import { ApiResponse } from '../../models/api-response.model';
import { TokenService } from '../token.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent extends BaseComponent {
  isLoading: boolean = false;
  returnUrl?: string | null;
  public selectedLanguage!: string;
  public loginForm!: FormGroup;
  public loginObj!: LoginInput;
  public isLoginSubmitted: boolean = false;
  public loginLoading: boolean = false;
  public passwordTextType: boolean = false;
  errorMsg: string = '';

  constructor(
    public translate: TranslateService,
    public _tokenService: TokenService,   
    private fb: FormBuilder
  ) {
    super();
  }

  ngOnInit(): void {
    this.selectedLanguage = this.translate.currentLang;
    this.checkReturnUrl();
    this.createLoginForm();
  }

  checkReturnUrl() {
    this.returnUrl = this.routeBase.snapshot.queryParamMap.get('returnUrl');
  }

  createLoginForm() {
    this.loginForm = this.fb.group({
      userName: [
        '',
        //[Validators.required, Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,6}$')],
        [Validators.required],
      ],
      password: ['', Validators.required],
    });
  }

  onLogin() {
    this.isLoginSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.loginLoading = true;
    this.loginObj = Object.assign({}, this.loginForm.value);
    this.authService.login(this.loginObj).subscribe({
      next: (res: ApiResponse<UserDto>) => {
        if (res.success && res.value) {
   
            this._tokenService.setToken(
              res.value.token,
              new Date(res.value.tokenExpiresAt)
            );
            this._tokenService.setRefreshToken(
              res.value.refreshToken,
              new Date(res.value.refreshTokenExpiresAt)
          );
            localStorage.setItem("currentAppUser", res.value.token);
            if (this.returnUrl) window.location.href = this.returnUrl;
            else window.location.href = '/dashboard';
          


          this.loginLoading = false;
        } else {
          this.errorMsg = res.message;
          this.loginLoading = false;
        }
      },
      error: (error: Error) => {
        this.loginLoading = false;
      },
    });
  }

  setLanguage(language: string): void {
    localStorage.setItem('lang', language);
    this.selectedLanguage = this.translate.currentLang;
    this.translate.set("lang", language);
    window.location.reload();
  }

  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }
}
